var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"height-100 back-color pl-20 pt-20 ql-container ql-snow"},[_vm._v(" 会员机制 ")])}
var staticRenderFns = []

export { render, staticRenderFns }